export default __webpack_public_path__ + "static/media/png.6abbf07f.png";